var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModuleLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00011 19.2493V20.2493C4.99194 20.4404 5.04454 20.6292 5.15036 20.7886C5.25619 20.948 5.40979 21.0697 5.58911 21.1363L12.5001 23.2493V14.4163L6.02711 12.0433C5.89893 12.0084 5.76418 12.0053 5.63454 12.0343C5.5049 12.0632 5.38427 12.1234 5.28311 12.2095C5.18195 12.2955 5.1033 12.405 5.05399 12.5284C5.00467 12.6517 4.98618 12.7852 5.00011 12.9173V14.7613",
    stroke: "#A5AAB5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.013 19.0983V20.2553C20.022 20.4465 19.9699 20.6355 19.8641 20.795C19.7584 20.9545 19.6046 21.0762 19.425 21.1423L12.5 23.2493V14.4163L18.986 12.0433C19.1142 12.0084 19.2489 12.0053 19.3786 12.0343C19.5082 12.0632 19.6288 12.1234 19.73 12.2095C19.8312 12.2955 19.9098 12.405 19.9591 12.5284C20.0084 12.6517 20.0269 12.7852 20.013 12.9173V14.9053",
    stroke: "#A5AAB5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48702 18.3579C6.48702 18.8579 5.92402 19.2579 5.23602 19.2509C3.85802 19.2449 2.74502 18.4349 2.75002 17.4409V16.5409C2.75002 15.5479 3.87502 14.7479 5.25002 14.7539C5.93902 14.7539 6.49502 15.1619 6.49302 15.6539L6.48702 18.3579Z",
    stroke: "#A5AAB5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.757 18.3579C17.757 18.8579 18.32 19.2579 19.01 19.2509C20.39 19.2449 21.505 18.4349 21.5 17.4409V16.5409C21.5 15.5479 20.373 14.7479 18.993 14.7539C18.304 14.7539 17.746 15.1619 17.749 15.6539L17.757 18.3579Z",
    stroke: "#A5AAB5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 9.00293C14.7901 9.00293 16.637 7.1561 16.637 4.87793C16.637 2.59976 14.7901 0.75293 12.512 0.75293C10.2338 0.75293 8.38696 2.59976 8.38696 4.87793C8.38696 7.1561 10.2338 9.00293 12.512 9.00293Z",
    stroke: "#A5AAB5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleLibrary);
export default __webpack_public_path__ + "static/media/module-library.4b6b7f2230b9af493536d2f96e0590d9.svg";
export { ForwardRef as ReactComponent };